// extracted by mini-css-extract-plugin
module.exports = {"heading":"HeadingA_heading__2jDs0"};